export const RequestModificationIcon = ({
  className,
}: {
  className?: string
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.99756 11H5.33089"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99756 11H9.66423"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6639 8.01968V10.7397C14.6639 13.0797 14.0706 13.6664 11.7039 13.6664H4.29057C1.9239 13.6664 1.33057 13.0797 1.33057 10.7397V5.25968C1.33057 2.91968 1.9239 2.33301 4.29057 2.33301H9.66391"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7176 2.75289L10.2442 5.22622C10.1509 5.31956 10.0576 5.50622 10.0376 5.63956L9.90424 6.58623C9.85757 6.92623 10.0976 7.16623 10.4376 7.11956L11.3842 6.98623C11.5176 6.96623 11.7042 6.87289 11.7976 6.77956L14.2709 4.30622C14.6976 3.87955 14.8976 3.38622 14.2709 2.75955C13.6376 2.12622 13.1442 2.32622 12.7176 2.75289Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3643 3.10645C12.5776 3.85978 13.1643 4.44645 13.9109 4.65311"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
